import { Entity } from '@core/entities/entity'
import { ILinkedChecklistResult } from './ILinkedChecklistResult'
import { plainToInstance, Type } from 'class-transformer'
import { User } from '@core/entities/user'
import { ChecklistStatus } from '@core/entities/checklist/Checklist'
import { TemplateProjectLocations } from '@core/entities/template/TemplateProjectLocations'
import { LinkedChecklistResultProject } from './LinkedChecklistResultProject/LinkedChecklistResultProject'
import { LinkedChecklistResultTemplate } from './LinkedChecklistResultTemplate/LinkedChecklistResultTemplate'

export class LinkedChecklistResult extends Entity<ILinkedChecklistResult> {
  id: number

  uuid: string

  uuidShort: string

  shortUUID: string

  organisationId: number

  locationName: string

  status: ChecklistStatus

  summary: string

  createdOn: string

  commentsCount: number

  templateName: string

  code: string

  questionId: string

  @Type(() => LinkedChecklistResultProject)
  project: LinkedChecklistResultProject

  @Type(() => LinkedChecklistResultTemplate)
  template: LinkedChecklistResultTemplate

  @Type(() => TemplateProjectLocations)
  projectLocations: TemplateProjectLocations

  @Type(() => User)
  createdBy: User

  public static new(payload: unknown): LinkedChecklistResult {
    const entity = plainToInstance(LinkedChecklistResult, payload)

    return entity
  }
}
